(function(root){
'use strict';
function quote(c,zone,now){
 const domestic=zone==='peninsula'||zone==='baleares',international=zone==='fr'||zone==='pt';
 if(!domestic&&!international)return null;
 const goal=domestic?4000:10000,shipping=domestic?500:800;
 if(c.total>=goal)return null;
 const promo=now<new Date(c.promoUntil).getTime(),options=c.candidates.map(item=>[item]),missing=c.candidates.filter(item=>!item.reserve);
 if(missing.length>1)options.push(missing);
 const offers=options.map(items=>{
 const addition=items.reduce((sum,p)=>sum+p.price,0),eligibleAddition=items.filter(p=>p.eligible).reduce((sum,p)=>sum+p.price,0),projected=c.total+addition;
 const ceiling=c.discount+c.count+items.filter(p=>p.eligible).reduce((sum,p)=>sum+Math.ceil(p.price*.15),0),promoPossible=promo&&c.eligible+eligibleAddition>=2500;
 return {items,addition,projected,promoPossible,qualifies:projected>=goal&&projected-(promoPossible?ceiling:0)>=goal,reserve:items.some(p=>p.reserve)};
 }).filter(o=>o.qualifies).sort((a,b)=>Number(a.reserve)-Number(b.reserve)||a.addition-b.addition);
 return offers.length?{offer:offers[0],shipping,goal}:null;
}
const api={quote};if(typeof module!=='undefined'&&module.exports)module.exports=api;else root.PrinkFreeShippingMath=api;
})(typeof window!=='undefined'?window:this);
